import LevelHide from './LevelHide';
import Seeker from '../seek/Seeker';
import OnboardingController from '../controller/OnboardingController';
import { MODE_SEEK, MODE_HIDE } from '../constants/AppConstants';
import { STATE_LEVEL_TWO_PLAYERS } from '../constants/StateConstants';
import { getGA } from 'analytics/GoogleAnalytics';

export default class LevelTwoPlayers extends LevelHide {
  create() {
    this.game.controller.gameMode = MODE_HIDE;

    super.create();

    //
    this.firstTimeCheckButton = true;

    //
    this.location.disableControls();
    this.gameHud.charactersList.lock();

    const playerIcon = this.game.controller.twoPlayersModel.getHidingPlayerIcon();
    const playerNr = this.game.controller.twoPlayersModel.hidingPlayerId + 1;
    this.gameHud.showCurrentPlayerIcon(playerIcon, playerNr);

    this.gameHud.showOverlayTPCharacters(this.charsData);
    this.gameHud.onCloseTPOverlay.add(this.handleOverlayCharactersClose, this);
  }

  create2() {}

  setCharsData() {
    this.charsData = this.levelData.characters.filter(
      (e) =>
        e.id !== this.game.controller.twoPlayersModel.playerIcon1 &&
        e.id !== this.game.controller.twoPlayersModel.playerIcon2
    );
  }

  startLevel() {
    this.game.twoPlayersOnboarding.playVOs(['ob_05_elinor_034']);
    this.location.enableControls();
    this.gameHud.charactersList.unlock();
  }

  handleOverlayCharactersClose() {
    this.gameHud.onCloseTPOverlay.remove(this.handleOverlayCharactersClose, this);

    if (this.game.controller.player.wasOnboardingDisplayed('onboarding_01')) {
      // 1 player onboarding was displayed
      this.startLevel();
    } else {
      let onboarding = 'onboarding_05a';
      if (
        this.game.controller.twoPlayersModel.playerIcon2 ===
        this.game.controller.twoPlayersModel.getHidingPlayerIcon()
      ) {
        // 2nd player is hiding
        onboarding = 'onboarding_05b';
      }

      this.game.onboarding = new OnboardingController(
        this.game,
        onboarding,
        this.game.cache.getJSON(onboarding + '_config'),
        this
      );
      this.game.onboarding.onEnd.addOnce(this.handleOnboardingEnd, this);
      this.game.onboarding.start();
    }
  }

  handleOnboardingEnd() {
    // init captions once again
    this.game.springRollCaptionsPlugin.setData(this.cptData);
    this.startLevel();
  }

  handleButtonContinue() {
    // lock placed characters
    this.location.lockCharacters();

    // change level mode
    this.location.disableControls();

    // hide scroll arrows
    this.gameHud.hideScrollArrows();

    // hide clothing buttons
    this.location.hideCharacterDressUpButtons();

    // add seeker
    this.seeker = new Seeker(
      this.game,
      this.seekerId,
      this.locationData.nav_points,
      this.levelData.start_point,
      100,
      this.levelData.sceneWidth - 100
    );
    this.location.placeSeeker(this.seeker);
    this.seeker.onStartWalk.add(this.handleSeekerStartWalk, this);
    this.seeker.onPosition.add(this.handleSeekerOnPosition, this);

    // add seeker to camera and position camera on seeker
    this.camera.setTarget(this.seeker);
    this.camera.setPosition(this.seeker.x);

    // show seeking alert
    this.gameHud.showOverlayTPSeekingAlert();
    this.gameHud.onCloseTPOverlay.add(this.handleOverlaySeekingClose, this);
  }

  handleOverlaySeekingClose() {
    // change player icon in hud
    const playerIcon = this.game.controller.twoPlayersModel.getSeekingPlayerIcon();
    const playerNr = ((this.game.controller.twoPlayersModel.hidingPlayerId + 1) % 2) + 1;
    this.gameHud.showCurrentPlayerIcon(playerIcon, playerNr);
    this.gameHud.playerIcon.setHudMode();

    // restore captions
    this.game.springRollCaptionsPlugin.setData(this.cptData);

    // show count overlay
    this.gameHud.onCountEnd.addOnce(this.handleCountEnd, this);
    this.gameHud.showOverlayCount(this.seekerId, false);
  }

  handleCountEnd() {
    this.transition.onFadeEnd.addOnce(this.handleTransitionEndToStart, this);
    this.transition.fadeIn();
  }

  handleTransitionEndToStart() {
    this.gameHud.removeOverlayCount();
    this.transition.fadeOut();

    // enter into seek mode and enable controls
    this.game.controller.gameMode = MODE_SEEK;

    // scroll arrows
    this.handleResize();
    this.gameHud.showScrollArrows(!this.seeker.atFirstNavPoint(), !this.seeker.atLastNavPoint());

    //
    this.location.addOnFindToSlots();
    this.location.onFindChar.add(this.handleFindChar, this);
    this.location.enableControls();

    this.location.unlockCharacters();
  }

  //
  handleResize() {
    this.calculateNavPoints();
    this.setCurrentNavPoint();
    if (this.seeker) {
      this.seeker.navPoints = this.navPoints;
      this.seeker.currentNavId = this.navPointId;
    }
  }

  handleScrollLeft() {
    if (this.game.controller.gameMode === MODE_SEEK) {
      this.setCurrentNavPoint();
      this.seeker.currentNavId = this.navPointId;

      this.seeker.gotoPrevNavPoint();
      this.gameHud.hideScrollArrows();
    } else {
      super.handleScrollLeft();
    }
  }

  handleScrollRight() {
    if (this.game.controller.gameMode === MODE_SEEK) {
      this.setCurrentNavPoint();
      this.seeker.currentNavId = this.navPointId;

      this.seeker.gotoNextNavPoint();
      this.gameHud.hideScrollArrows();
    } else {
      super.handleScrollRight();
    }
  }

  handleSeekerOnPosition() {
    this.setCurrentNavPoint();
    this.seeker.currentNavId = this.navPointId;

    this.gameHud.showScrollArrows(!this.seeker.atFirstNavPoint(), !this.seeker.atLastNavPoint());
  }

  handleSeekerStartWalk() {
    this.gameHud.hideScrollArrows();
  }

  //
  handleFindChar(characterId, bestHidingPlace) {
    // make seeker happy for short time

    // show in hud found character
    this.gameHud.charactersList.revealCharacter(characterId);

    // play vo "found you" with small delay for stars sfx
    const ind = Math.floor(3 * Math.random()); // todo: add voiceover 017
    const ids = ['011', '015', '016'];
    let voId = ids[ind];
    voId = bestHidingPlace ? '012' : voId;
    const textId = 'vo_01_' + this.seekerId + '_' + voId;
    this.game.springRollCaptionsPlugin.playCaption(textId);
    this.game.sounds.playVO(textId, {
      spriteID: this.seekerId + '_vo',
      delay: 400,
    });

    const data = this.cptData[textId];
    const time = data[data.length - 1].end;
    this.seeker.stop();
    this.seeker.pointCharacter();
    this.seeker.talk(time, 450);

    // register next seeker -> first found character
    // if (this.found === 0) {
    //   this.game.controller.nextSeekerId = characterId;
    // }

    //
    // this.found++;
    // if (this.found >= this.toFind) {
    //   this.transition.onFadeEnd.addOnce(this.showResult, this);
    //   this.transition.fadeIn();
    // } else {
    //   this.game.time.events.add(1500, this.enableControls, this);
    // }

    this.found++;
    if (this.found >= this.toFind) {
      // all found - end of the level
      this.game.time.events.add(time + 450, this.showResult, this);
    } else {
      // seek next
      this.game.time.events.add(time + 450, this.enableControls, this);
    }

    //
    this.gameHud.arrowsContainer.visible = false;
    this.location.disableControls();
    this.location.lockCharacters();
  }

  enableControls() {
    this.gameHud.arrowsContainer.visible = true;
    this.location.enableControls();
    this.location.unlockCharacters();
  }

  showResult() {
    this.transition.onFadeEnd.addOnce(this.handleTransitionEndToResult, this);
    this.transition.fadeIn();
  }

  handleTransitionEndToResult() {
    // tracking
    let season = this.game.controller.location;
    season = season.replace(/^\w/, (chr) => chr.toUpperCase());
    const action = 'EndLevel_' + season;
    let value = 0;
    const slots = this.location.getSlotsWithChars();
    for (let i = 0; i < slots.length; i++) {
      value += slots[i].rating + 1;
    }

    getGA().track({ action: action, value: value });

    //
    this.gameHud.onCloseResult.addOnce(this.handleCloseResult, this);
    this.gameHud.showOverlayResult(this.seekerId, this.charsData);
    this.transition.fadeOut();
  }

  handleCloseResult() {
    if (this.game.controller.twoPlayersModel.hidingPlayerId === 0) {
      // change player
      this.game.controller.twoPlayersModel.changeHidingPlayer();

      //
      this.firstTimeCheckButton = true;

      // show overlay
      this.gameHud.showOverlayTPPlayerTwoTurn();
      this.gameHud.onCloseTPOverlay.add(this.handleOverlayPlayerTwoTurnClose, this);
    } else {
      // this.game.controller.endLevel();
      this.gameHud.showOverlayTPEndScreen();
    }
  }

  handleOverlayPlayerTwoTurnClose() {
    this.gameHud.onCloseTPOverlay.remove(this.handleOverlayPlayerTwoTurnClose, this);

    this.game.controller.startState(STATE_LEVEL_TWO_PLAYERS, {
      levelData: this.levelData,
      seekerId: this.game.controller.twoPlayersModel.getSeekingPlayerIcon(),
    });
  }

  displayContinueButton() {
    super.displayContinueButton();
    if (this.firstTimeCheckButton) {
      this.firstTimeCheckButton = false;

      const voID = this.game.device.desktop ? 'ob_05_elinor_017_click' : 'ob_05_elinor_017_tap';
      this.game.twoPlayersOnboarding.playVOs([voID]);
    }
  }

  update() {
    super.update();

    // keyboard controls
    if (this.location.controlsEnabled && this.game.controller.gameMode === MODE_SEEK) {
      if (this.game.input.keyboard.isDown(Phaser.Keyboard.LEFT)) {
        this.seeker.gotoPosition(this.seeker.x - 10);
      }
      if (this.game.input.keyboard.isDown(Phaser.Keyboard.RIGHT)) {
        this.seeker.gotoPosition(this.seeker.x + 10);
      }
    }
  }

  shutdown() {
    if (this.game.twoPlayersOnboarding) {
      this.game.twoPlayersOnboarding.stopVO();
    }

    super.shutdown();
  }
}
